import { List, Record } from 'immutable';
import { Utils } from '@kineticdata/bundle-common';
const { noPayload, withPayload } = Utils;
const ns = Utils.namespaceBuilder('settings/approvals');

export const types = {
  FETCH_TEAMS_REQUEST: ns('FETCH_TEAMS_REQUEST'),
  FETCH_TEAMS_SUCCESS: ns('FETCH_TEAMS_SUCCESS'),
  FETCH_TEAMS_FAILURE: ns('FETCH_TEAMS_FAILURE'),

  FETCH_AGREEMENT_TEAM_REQUEST: ns('FETCH_AGREEMENT_TEAM_REQUEST'),
  FETCH_AGREEMENT_TEAM_SUCCESS: ns('FETCH_AGREEMENT_TEAM_SUCCESS'),
  FETCH_AGREEMENT_TEAM_FAILURE: ns('FETCH_AGREEMENT_TEAM_FAILURE'),
  FETCH_AGREEMENT_USERS_SUCCESS: ns('FETCH_AGREEMENT_USERS_SUCCESS'),
  FETCH_AGREEMENT_USERS_FAILURE: ns('FETCH_AGREEMENT_USERS_FAILURE'),

  FETCH_APPROVAL_FORMS_REQUEST: ns('FETCH_APPROVAL_FORMS_REQUEST'),
  FETCH_APPROVAL_FORMS_SUCCESS: ns('FETCH_APPROVAL_FORMS_SUCCESS'),
  FETCH_APPROVAL_FORMS_FAILURE: ns('FETCH_APPROVAL_FORMS_FAILURE'),

  CREATE_APPROVAL_TEAM_REQUEST: ns('CREATE_APPROVAL_TEAM_REQUEST'),
  DELETE_APPROVAL_TEAM_REQUEST: ns('DELETE_APPROVAL_TEAM_REQUEST'),
  ADD_APPROVAL_MANAGER_REQUEST: ns('ADD_APPROVAL_MANAGER_REQUEST'),
  REMOVE_APPROVAL_MANAGER_REQUEST: ns('REMOVE_APPROVAL_MANAGER_REQUEST'),
  ADD_APPROVER_REQUEST: ns('ADD_APPROVER_REQUEST'),
  REMOVE_APPROVER_REQUEST: ns('REMOVE_APPROVER_REQUEST'),
  ADD_APPROVAL_FORM_REQUEST: ns('ADD_APPROVAL_FORM_REQUEST'),
  REMOVE_APPROVAL_FORM_REQUEST: ns('REMOVE_APPROVAL_FORM_REQUEST'),

  ACTION_COMPLETE: ns('ACTION_COMPLETE'),
};

export const actions = {
  fetchTeamsRequest: noPayload(types.FETCH_TEAMS_REQUEST),
  fetchTeamsSuccess: withPayload(types.FETCH_TEAMS_SUCCESS),
  fetchTeamsFailure: withPayload(types.FETCH_TEAMS_FAILURE),

  fetchAgreementTeamRequest: withPayload(types.FETCH_AGREEMENT_TEAM_REQUEST),
  fetchAgreementTeamSuccess: withPayload(types.FETCH_AGREEMENT_TEAM_SUCCESS),
  fetchAgreementTeamFailure: withPayload(types.FETCH_AGREEMENT_TEAM_FAILURE),
  fetchAgreementUsersSuccess: withPayload(types.FETCH_AGREEMENT_USERS_SUCCESS),
  fetchAgreementUsersFailure: withPayload(types.FETCH_AGREEMENT_USERS_FAILURE),

  fetchApprovalFormsRequest: withPayload(types.FETCH_APPROVAL_FORMS_REQUEST),
  fetchApprovalFormsSuccess: withPayload(types.FETCH_APPROVAL_FORMS_SUCCESS),
  fetchApprovalFormsFailure: withPayload(types.FETCH_APPROVAL_FORMS_FAILURE),

  createApprovalTeamRequest: withPayload(types.CREATE_APPROVAL_TEAM_REQUEST),
  deleteApprovalTeamRequest: withPayload(types.DELETE_APPROVAL_TEAM_REQUEST),
  addApprovalManagerRequest: withPayload(types.ADD_APPROVAL_MANAGER_REQUEST),
  removeApprovalManagerRequest: withPayload(
    types.REMOVE_APPROVAL_MANAGER_REQUEST,
  ),
  addApproverRequest: withPayload(types.ADD_APPROVER_REQUEST),
  removeApproverRequest: withPayload(types.REMOVE_APPROVER_REQUEST),
  addApprovalFormRequest: withPayload(types.ADD_APPROVAL_FORM_REQUEST),
  removeApprovalFormRequest: withPayload(types.REMOVE_APPROVAL_FORM_REQUEST),

  actionComplete: withPayload(types.ACTION_COMPLETE),
};

export const State = Record({
  teamsMap: null,
  teamsLoading: false,
  teamsError: null,

  currentAgreementTeam: null,
  agreementTeam: null,
  agreementTeamMaster: null,
  agreementTeamChildren: null,
  agreementTeamLoading: false,
  agreementTeamError: null,

  agreementUsers: null,
  agreementUsersError: null,

  approvalForms: null,
  approvalFormsLoading: false,
  approvalFormsError: null,

  actionsPending: 0,
});

export const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_TEAMS_REQUEST:
      return state.set('teamsLoading', true).set('teamsError', null);
    case types.FETCH_TEAMS_SUCCESS:
      return state.set('teamsLoading', false).set('teamsMap', payload);
    case types.FETCH_TEAMS_FAILURE:
      return state.set('teamsLoading', false).set('teamsError', payload);

    case types.FETCH_AGREEMENT_TEAM_REQUEST:
      return state.currentAgreementTeam === payload
        ? state
            .set('agreementTeamLoading', true)
            .set('agreementTeamError', null)
        : state
            .set('currentAgreementTeam', payload)
            .set('agreementTeamLoading', true)
            .set('agreementTeamError', null)
            .set('agreementTeam', null)
            .set('agreementTeamMaster', null)
            .set('agreementTeamChildren', null)
            .set('agreementUsersError', null)
            .set('agreementUsers', null)
            .set('approvalFormsLoading', true)
            .set('approvalFormsError', null)
            .set('approvalForms', null);
    case types.FETCH_AGREEMENT_TEAM_SUCCESS:
      return state
        .set('agreementTeamLoading', false)
        .set('agreementTeam', payload.team)
        .set('agreementTeamMaster', payload.master)
        .set('agreementTeamChildren', List(payload.children));
    case types.FETCH_AGREEMENT_TEAM_FAILURE:
      return state
        .set('agreementTeamLoading', false)
        .set('agreementTeamError', payload);
    case types.FETCH_AGREEMENT_USERS_SUCCESS:
      return state
        .set('agreementUsersLoading', false)
        .set('agreementUsers', List(payload));
    case types.FETCH_AGREEMENT_USERS_FAILURE:
      return state
        .set('agreementUsersLoading', false)
        .set('agreementUsersError', payload);

    case types.FETCH_APPROVAL_FORMS_REQUEST:
      return state
        .set('approvalFormsLoading', true)
        .set('approvalFormsError', null);
    case types.FETCH_APPROVAL_FORMS_SUCCESS:
      return state
        .set('approvalFormsLoading', false)
        .set('approvalForms', List(payload));
    case types.FETCH_APPROVAL_FORMS_FAILURE:
      return state
        .set('approvalFormsLoading', false)
        .set('approvalFormsError', payload);

    case types.CREATE_APPROVAL_TEAM_REQUEST:
    case types.DELETE_APPROVAL_TEAM_REQUEST:
    case types.ADD_APPROVAL_MANAGER_REQUEST:
    case types.REMOVE_APPROVAL_MANAGER_REQUEST:
    case types.ADD_APPROVER_REQUEST:
    case types.REMOVE_APPROVER_REQUEST:
    case types.ADD_APPROVAL_FORM_REQUEST:
    case types.REMOVE_APPROVAL_FORM_REQUEST:
      return state.update('actionsPending', a => a + 1);
    case types.ACTION_COMPLETE:
      return state.update('actionsPending', a => a - 1);

    default:
      return state;
  }
};
